import { useMemo } from 'react';

import { doc, DocumentReference } from 'firebase/firestore';

import { useDocumentData } from 'react-firebase-hooks/firestore';

import { useAuth } from '../contextProviders/AuthProvider';
import { firestore } from '../firebase';
import { resolveUsgaSettings, USGA_SETTINGS_PATH } from '../types/UsgaSettings';

import type { UsgaSettings } from '../types/UsgaSettings';

/** God only: the USGA integration's settings (usgaSync/settings), with defaults for anything unset. */
export default function useUsgaSettings() {
  const { isGod } = useAuth();
  const ref = useMemo(
    () => (isGod ? doc(firestore, USGA_SETTINGS_PATH) as DocumentReference<Partial<UsgaSettings>> : null),
    [isGod],
  );
  const [stored, isLoading] = useDocumentData<Partial<UsgaSettings>>(ref);
  const settings = useMemo(() => resolveUsgaSettings(stored), [stored]);
  return { settings, isLoading };
}
